export default __webpack_public_path__ + "static/media/Group1268@2x.4fb33d1d.png";